export default __webpack_public_path__ + "static/media/Mark-6-Suit-01.f7c4b3d6.jpg";